import React, { Component } from 'react'
import Dropdown from '@/components/Dropdown/Dropdown';
import Input from '../Input/index';
import '../../assets/styles/components/instrument/place-order-option.scss'
import { connect } from 'react-redux';
import { formatFunctions, utilsFunction } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import { INDEX_KEY } from '@/constants/keys.code';
import { ORDER_TYPE, STOP_TYPE_TYPE, FUND_ACTION_TYPES, FUND_ACTION_COLOR } from '@/constants/app';
import classnames from 'classnames';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { openPrePostDialog } from '@/actions/app/dialog.action'
import descriptionIcon from '@/assets/images/icons/icon_description.png';
import DatePicker  from '@/components/DatePicker/DatePicker';
import { orderActions, accountActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';

const DESELECT_OPTION = '--';
const stopStockPriceMinusStep ={
  'tableCode': '01',
  'fromPrice': '0.001',
  'toPrice': '0.25',
  'spread': '0.001'
}
const stopStockPricePlusStep = {
  'tableCode': '01',
  'fromPrice': '0.001',
  'toPrice': '0.25',
  'spread': '0.001'
}
const priceStockMinusStep ={
  'tableCode': '01',
  'fromPrice': '0.001',
  'toPrice': '0.25',
  'spread': '0.001'
}
const priceStockPlusStep = {
  'tableCode': '01',
  'fromPrice': '0.001',
  'toPrice': '0.25',
  'spread': '0.001'
}
const priceFundMinusStep ={
  'tableCode': 'BF',
  'fromPrice': '0.000001',
  'toPrice': '999999999',
  'spread': '0.000001'
}
const priceFundPlusStep = {
  'tableCode': 'BF',
  'fromPrice': '0.000001',
  'toPrice': '999999999',
  'spread': '0.000001'
}
class PlaceOrderOption extends Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      orderType: props.orderType ? props.orderType : props.orderTypes.length > 0 ? props.orderTypes[0].value : '',
      priceMinusStep: priceStockMinusStep,
      pricePlusStep: priceStockPlusStep,
      stopPriceMinusStep: stopStockPriceMinusStep,
      stopPricePlusStep: stopStockPricePlusStep,

      newGoodTillDates: [{ value: DESELECT_OPTION, label: DESELECT_OPTION }, ...props.goodTillDates],
      grossAmount: '-',
      fundAmount: '-',
      fundUnit: '-',
      priceSelectList : false,
      quantitySelectList : false,
      selectPriceListData : [`${this.props.language.follow_price}`,`${this.props.language.follow_bid1}`,`${this.props.language.follow_ask1}`],
      availablebuy:'-',
      avaiableQuantity : '-',
      selectQuatitybuyListData :[
        {
          label: `${this.props.language.available_for_buy}`,
          value : '-',
          proportion:'',
          id:'1'
        },
        {
          label: `${this.props.language.common_buy}`,
          value : '-',
          proportion:'1/2',
          id:'2'
        },
        {
          label:  `${this.props.language.common_buy}`,
          value : '-',
          proportion:'1/4',
          id:'3'
        }
      ],
      selectQuatitysellListData :[
        {
          label: `${this.props.language.available_for_sell}`,
          value : '-',
          proportion:'',
          id:'4'
        },
        {
          label: `${this.props.language.common_sell}`,
          value : '-',
          proportion:'1/2',
          id:'5'
        },
        {
          label: `${this.props.language.common_sell}`,
          value : '-',
          proportion:'1/4',
          id:'6'
        }
      ],
      datepicker:false,
      InputLabel:'common_quantity',
      InputLabelPrice:'common_price',
    }
    this.renderStockOption = this.renderStockOption.bind(this)
    this.renderFundOption = this.renderFundOption.bind(this)
    this.renderFundSubscription = this.renderFundSubscription.bind(this)
    this.renderFundRedemption = this.renderFundRedemption.bind(this)

    this.handleFundActionClick = this.handleFundActionClick.bind(this)
  }

  renderStockOption() {
    const { 
      language, 
      tradeInformation, 
      lotSize, 
      orderTypes, 
      isModifyOrder, 
      showGrossAmount, 
      showGrossAmountBorder , 
      currencyID , 
      cashAccountData , 
    } = this.props;
    const {
      priceMinusStep,
      pricePlusStep,
      newGoodTillDates,
      orderType,
      stopPriceMinusStep,
      stopPricePlusStep,
      grossAmount,
      priceSelectList,
      quantitySelectList,
      selectPriceListData,
      availablebuy,
      avaiableQuantity,
      selectQuatitybuyListData,
      selectQuatitysellListData,
      datepicker,
      InputLabelPrice,
      InputLabel
    } = this.state;
    const usePrePost = iTradeEnv?.pages?.trade?.usePrePost
    return (
      <div className="place-order-option-container">
        {!isModifyOrder && <div className="option-item">
          <label>{language.common_order_type}</label>
          <div className="input">
            <Dropdown
              textCenter
              style={{ height: '30px', width: '100%', textAlign: 'left' }}
              selectedOptions={[this.hasOption(orderTypes, orderType, orderTypes[0])]}
              options={orderTypes}
              innerRef={e => this.orderTypeRef = e}
              onChange={this.handleChangeOrderType}
            />
          </div>
        </div>}
        {!isModifyOrder && orderType === ORDER_TYPE.TRIGGER_ORDER.value &&
          <div className="option-item">
            <label>{language.common_stop_price}</label>
            <div className="input stop-price-input">
              <Dropdown
                textCenter
                style={{ height: '30px' }}
                selectedOptions={[STOP_TYPE_TYPE[0]]}
                options={STOP_TYPE_TYPE}
                innerRef={e => this.stopTypeDirectionRef = e}
              />
              <Input style={{ height: '30px', flexGrow: '1' }}
                innerRef={e => this.stopPriceRef = e}
                priceMode={true}
                minusStep={stopPriceMinusStep.spread}
                plusStep={stopPricePlusStep.spread}
                onChange={(price) => this.handleChangePrice(price, true)}
                // prevKey={INDEX_KEY.PRICE}
                currentKey={INDEX_KEY.STOP_PRICE}
                // nextKey={INDEX_KEY.GTD}
                onKeyPress={this.keySequence}
              />
            </div>
          </div>}
        {utilsFunction.isOrderNeedEnterPrice(orderType) && <div className="option-item">
          {isModifyOrder
            ? <label for={InputLabelPrice}>{language.order_new_properties.format(language.common_price)}</label>
            : <label for={InputLabelPrice}>{language.common_price}</label>
          }
          <div className="input">
            <Input style={{ width: '100%', height: '30px' }}
              id={InputLabelPrice}
              innerRef={e => this.priceRef = e}
              priceMode={true}
              minusStep={priceMinusStep.spread}
              plusStep={pricePlusStep.spread}
              onChange={this.handleChangePrice}
              prevKey={INDEX_KEY.ORDER_TYPE}
              currentKey={INDEX_KEY.PRICE}
              nextKey={INDEX_KEY.QTY}
              autoComplete = {'off'}
              onKeyPress={this.keySequence} />
              <span className='pirce-icon' title="pirce-icon" onClick={(e)=>{
              this.setState({priceSelectList : !priceSelectList , quantitySelectList : false});
              e.nativeEvent.stopImmediatePropagation()}} ></span>
              {priceSelectList && <div className='price-list'>
                {
                  selectPriceListData.map((item, index)=>
                  <div key={index} className='price-selct-item' onClick={()=>this.selectPrice(index)}>
                    <span >{item}</span>
                  </div>
                  )
                }
                  
                  {/* <div className='price-selct-item' onClick={()=>this.selectPrice(event)}>
                    <span>{language.follow_bid1}</span>
                  </div>
                  <div className='price-selct-item' onClick={()=>this.selectPrice(event)}>
                    <span>{language.follow_ask1}</span>
                  </div> */}
              </div>}
          </div>
        </div>}
        <div className="option-item">
          {isModifyOrder
            ? <label for={InputLabel}>{language.order_new_properties.format(language.common_quantity)}</label>
            : <label for={InputLabel}>{language.common_quantity}</label>
          }
          <div className="input">
            <Input style={{ width: '100%', height: '30px' }}
              id={InputLabel}
              innerRef={e => this.quantityRef = e}
              step={lotSize}
              onChange={this.handleChangeQuantity}
              prevKey={INDEX_KEY.PRICE}
              currentKey={INDEX_KEY.QTY}
              nextKey={INDEX_KEY.GTD}
              onKeyPress={this.keySequence}
              dataType={dataType.NUMBER} />
              <span className='quantity-icon' onClick={(e)=>{
              this.setState({quantitySelectList : !quantitySelectList , priceSelectList:false})
              e.nativeEvent.stopImmediatePropagation()
              }}></span>
              {quantitySelectList && <div className='quantity-list'>
                  <div className='quantity-selct-buy-item' >
                  {selectQuatitybuyListData.map((item,index)=>
                   <span className={classnames('item' , 'buy-item')} onClick={()=>this.selectQuantity(item)} key={index}>
                      {item.label} {item.proportion}
                      <span className='price' >{formatFunctions.dataFormat(item.value , dataType.NUMBER)}</span> 
                    </span>)}
                  </div>
                  <div className='quantity-selct-sell-item'>
                    {selectQuatitysellListData.map((item,index)=>
                    <span className={classnames('item' , 'sell-item')} onClick={()=>this.selectQuantity(item)} key={index}>
                      {item.label} {item.proportion}
                      <span className='price'>{formatFunctions.dataFormat(item.value , dataType.NUMBER)}</span> 
                    </span>)}
                  </div>
              </div>}
          </div>
        </div>
        {!isModifyOrder && <div className="option-item">
          <label for="commonGoodTillDate">{language.common_good_till_date}</label>
          <div className="input">
            <input className='datepicker' defaultValue={"-"} 
            id="commonGoodTillDate"
            ref={e => this.goodTillDateRef = e }  
            onFocus={()=>{this.setState({datepicker : true})}}
            onBlur={()=> {this.setState({datepicker : false})}}
            readOnly
            >
            </input>
            <span className={classnames('date-icon' )}
             onClick={this.setDatepicker}
             onMouseDown={(e)=>{e.preventDefault()}}
            ></span>
            {datepicker && <DatePicker   
              setGoodTillDate={this.setGoodTillDate}
              data = {this.props.goodTillDates}
              defaultValue = {this.goodTillDateRef.value=="-"?this.props.goodTillDates[0].value:this.goodTillDateRef.value}
            />} 
          </div>
          
        </div>}
        {/* {!isModifyOrder && <div className="option-item">
          <label>{language.common_good_till_date}</label>
          <div className="input">
            <Dropdown
              textCenter
              style={{ height: '30px', width: '100%', textAlign: 'left' }}
              selectedOptions={[newGoodTillDates[0]]}
              options={newGoodTillDates}
              innerRef={e => this.goodTillDateRef = e}
            />
          </div>
        </div>} */}
        {usePrePost && <div className="option-item" style={{height:'30px'}}>
          <label onClick={() => {usePrePost && openPrePostDialog()}} className="description_label">
            {language.common_order_statement}
            <img src={descriptionIcon}/>
          </label>
        </div>}
        {<div className={classnames("available-buy-sell")}>
          <div className = 'available-buy'>
            <label>{language.available_for_buy}</label>
            <span>{availablebuy}</span>
          </div>
          <div className = 'available-sell'>
            <label>{language.available_for_sell}</label>
            <span>{avaiableQuantity || '-'}</span>
          </div>
        </div>}
        {<div className="asset-index">
          {/* <div className="asset-item">
            <label>{language.common_buying_power}</label>
            <label className="value">
              <span>{currencyID}</span>
              <span>{cashAccountData.buyingPower || '-'}</span>
            </label>
          </div> */}
          <div className="asset-item" style={{width:'100%'}}>
            <label>{language.place_order_dialog_gross_amount}</label>
            <label className="value">
              <span>{currencyID}</span>
              <span>{grossAmount}</span>
            </label>
          </div>
        </div>}
      </div>
    )
  }

  renderFundSubscription() {
    const { language, goodTillDates, currencyID } = this.props
    const { stopPriceMinusStep, stopPricePlusStep, datepicker, fundAmount } = this.state;

    return (
      <>
        <div className='option-item fund-currency'>
          <label>{language.common_currency}</label>
          <div className="input">
            <input className='c-input fund-currency-value' value={currencyID || '-'} readOnly />
          </div>
        </div>
        <div className='option-item fund-amount'>
          <label htmlFor='fund_amount'>{language.common_funds_amount}</label>
          <div className='input'>
          <Input 
            className="fund-amount-value"
            style={{ height: '30px', flexGrow: '1' }}
            innerRef={e => this.amountRef = e}
            priceMode={true}
            minusStep={stopPriceMinusStep.spread}
            plusStep={stopPricePlusStep.spread}
            onChange={(price) => this.handleChangePrice(price, true)}
            currentKey={INDEX_KEY.AMOUNT}
            onKeyPress={this.keySequence}
            dataType={dataType.STOP_PRICE}
            />
          </div>
        </div>
        <div className='option-item fund-time'>
          <label for="commonGoodTillDate">{language.common_good_till_date}</label>
          <div className="input">
            <input
              id="commonGoodTillDate"
              className='datepicker' 
              defaultValue={"-"} 
              ref={e => this.goodTillDateRef = e }  
              onFocus={()=>{this.setState({datepicker : true})}}
              onBlur={()=> {this.setState({datepicker : false})}}
              readOnly
              />
            <span className={classnames('date-icon' )}
             onClick={this.setDatepicker}
             onMouseDown={(e)=>{e.preventDefault()}}
            ></span>
            {datepicker && <DatePicker   
              setGoodTillDate={this.setGoodTillDate}
              data={goodTillDates}
              defaultValue = {this.goodTillDateRef.value == "-" ? this.props.goodTillDates[0].value: this.goodTillDateRef.value}
            />} 
          </div>
        </div>
        <div className='option-item subscription-fee'>
          <label className='fund-fee-label'>{language.common_funds_subscription_fee}</label>
          <div className='input text-right'>
            <span>{fundAmount}</span>
          </div>
        </div>
      </>
    )
  }

  renderFundRedemption() {
    const { language, goodTillDates, lotSize } = this.props
    const { datepicker, fundUnit } = this.state
    return (
      <>
        {/* <div className='option-item fund-currency'>
          <label>{language.common_currency}</label>
          <div className="input">
            <input className='c-input fund-currency-value' value='HKD' readOnly />
          </div>
        </div> */}
        <div className='option-item fund-unit'>
          <label>{language.common_funds_unit}</label>
          <div className='input'>
            <Input 
              className="fund-unit-value"
              style={{ width: '100%', height: '30px' }}
              innerRef={e => this.unitRef = e}
              step={lotSize}
              onChange={(unit) => this.handleChangeQuantity(unit)}
              prevKey={INDEX_KEY.PRICE}
              currentKey={INDEX_KEY.UNIT}
              nextKey={INDEX_KEY.GTD}
              onKeyPress={this.keySequence}
              dataType={dataType.FUNDS_QUANTITY} />
            <span className='unit-icon' onClick={this.handleSetUnitAllClick}>{language.common_funds_all}</span>
          </div>
        </div>
        <div className='option-item fund-time'>
          <label for="commonGoodTillDate">{language.common_good_till_date}</label>
          <div className="input">
            <input
              id="commonGoodTillDate"
              className='datepicker' 
              defaultValue={"-"} 
              ref={e => this.goodTillDateRef = e }  
              onFocus={()=>{this.setState({datepicker : true})}}
              onBlur={()=> {this.setState({datepicker : false})}}
              readOnly
              />
            <span className='date-icon'
             onClick={this.setDatepicker}
             onMouseDown={(e)=>{e.preventDefault()}}
            ></span>
            {datepicker && <DatePicker   
              setGoodTillDate={this.setGoodTillDate}
              data = {goodTillDates}
              defaultValue = {this.goodTillDateRef.value == "-" ? this.props.goodTillDates[0].value: this.goodTillDateRef.value}
            />} 
          </div>
        </div>
        <div className='option-item fund-redemption-fee'>
          <label className='fund-fee-label'>{language.common_funds_redemption_fee}</label>
          <div className='input text-right'>
            <span>{fundUnit}</span>
          </div>
        </div>
      </>
    )
  }

  renderFundOption() {
    const { language, currentFundActionType } = this.props
    const currentActionBgColor = FUND_ACTION_COLOR[currentFundActionType]
    const renderActionComponent = this[`renderFund${currentFundActionType}`]

    return (
      <div className='place-order-option-container'>
        <div className='option-item fund-actions'>
          <label>{language.common_actions}</label>
          <ul className={classnames('fund-actions-options')}>
            {Object.values(FUND_ACTION_TYPES).map(val => {
              return (
                <li key={val} className={classnames('fund-actions-item', val === currentFundActionType && 'fund-actions-active')} onClick={() => this.handleFundActionClick(val)}>
                  <span className='fund-actions-text'>{language[`common_funds_${val.toLowerCase()}`]}</span>
                </li>
              )
            })}
            <li className={classnames('fund-action-active', `fund-action-${currentActionBgColor}`)}></li>
          </ul>
        </div>
        {renderActionComponent()}
      </div>
    )
  }

  render() {
    const { currentMarket } = this.props
    const marketType = currentMarket === 'FUND' ? 'Fund' : 'Stock'
    return this[`render${marketType}Option`]()
  }

  handleFundActionClick(key) {
    const { currentFundActionType } = this.props
    if (currentFundActionType === key) return
    this.clearFundValues()
    setTimeout(() => this.props.handleFundActionClick(key))
  }

  handleSetUnitAllClick = () => {
    // const { currentTradingAccount, currentMarket, instrument, language} = this.props

    const avaiableQuantity = formatFunctions.dataFormat(this.props.avaiableQuantity ,dataType.STOP_PRICE)
    this.unitRef?.setValue(avaiableQuantity)
    this.handleFundFee(this.props.avaiableQuantity)
    // const params = {
    //   [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
    //   [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
    //   [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
    //   [PARAMS.MARKET_ID]: currentMarket,
    //   [PARAMS.INSTRUMENT_ID]: instrument.instrumentID,
    //   [PARAMS.LANGUAGE]: language.lang
    // }
    // this.props.getAvailableQuantity(params, res => {
    //   if (res.status === SERVICES_RESP.STATUS_OK) {
    //     if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE && res.result.avaiableQuantity) {
    //       const avaiableQuantity = formatFunctions.dataFormat(res.result.avaiableQuantity ,dataType.STOP_PRICE)
    //       this.unitRef?.setValue(avaiableQuantity)
    //       this.handleFundFee(res.result.avaiableQuantity)
    //     }
    //   }
    // })
  }

  hasOption = (options, value, defaultOption) => {
    const hasItem = options.find(v => v.value === value)
    if (hasItem) return hasItem
    return defaultOption
  }

  computeGrossAmount = (price, quantity) => {
    const { currencyID } = this.props;
    const grossAmount = formatFunctions.dataFormat(price * quantity, dataType.CASH);
    // const grossAmountText = `${grossAmount > 0 ? currencyID : ''} ${grossAmount}`
    this.setState({ grossAmount: grossAmount })
  }

  handleChangeOrderType = (orderType) => {
    if (orderType.length > 0) {
      this.setState({
        orderType: orderType[0].value 
      })
      if(orderType[0].value === ORDER_TYPE.AT_AUCTION.value ){
        this.setState({
          grossAmount:'-'
        })
      }
      this.props.handleAllowBuy(orderType);
    }
  }

  clearFundValues() {
    this.amountRef?.setValue('0')
    this.unitRef?.setValue('0')
    this.goodTillDateRef.value = '-'
    this.setState({ fundAmount: '-', fundUnit: '-' })
  }

  handleChangeQuantity = (quantity) => {
    const { currentMarket } = this.props

    if (currentMarket === 'FUND') {
      this.handleFundFee(quantity)
    } else {
      let changeData;
      if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
        changeData = {
          price: this.priceRef.getValue(),
          quantity,
        }
      }else{
        changeData = {
          price: '',
          quantity,
        }
      }
      if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER) {
        changeData.stopPrice = this.stopPriceRef.getValue()
      }
      this.props.onChange(changeData);
      if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
        this.computeGrossAmount(changeData.price, changeData.quantity);
      }
    }
  }

  handleFundFee = utilsFunction.debounce((number) => {
    const { currentFundActionType, currentTradingAccount, instrument, language } = this.props
    const isBuy = currentFundActionType === FUND_ACTION_TYPES.SUBSCRIPTION

    if (!number && isNaN(number) || number == '0') {
      return this.setState({ [isBuy ? 'fundAmount' : 'fundUnit']: '-' })
    }

    const params = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq + '',
      [PARAMS.MARKET_ID]: instrument.marketID,
      [PARAMS.INSTRUMENT_ID]: instrument.instrumentID,
      [PARAMS.BS]: isBuy ? 'B' : 'S',
      [PARAMS.LANGUAGE]: language.lang,
      [isBuy ? PARAMS.PRICE : PARAMS.QTY]: Number((number + '').replaceAll(',', '')),
    }

    this.props.getOrderFeesAction(params, res => {
      if (res.status === 'ST200' && res.result && Array.isArray(res.result.feesList) && res.result.feesList.length) {
        const fessData = res.result.feesList.find(v => v.feeID === (isBuy ? 'FUND.SUB' : 'FUND.REDEM'))
        if (fessData) {
          const { chargeRate } = fessData
          if (!isNaN(chargeRate)) {
            this.setState({ [isBuy ? 'fundAmount' : 'fundUnit']: formatFunctions.dataFormat(chargeRate * 100, dataType.CASH) })
          } else {
            this.setState({ [isBuy ? 'fundAmount' : 'fundUnit']: '-' })
          }
        }
      }
    })
  }, 500)

  handleChangePrice = (price, isStopPrice = false) => {
    const { currentMarket } = this.props
    const { priceMinusStep, pricePlusStep, stopPriceMinusStep, stopPricePlusStep } = this.state;
    const priceNumber = parseFloat(price);
    if (!isNaN(priceNumber)) {
      const minusStep = isStopPrice ? stopPriceMinusStep : priceMinusStep;
      const plusStep = isStopPrice ? stopPricePlusStep : pricePlusStep;
      if (minusStep.fromPrice === plusStep.fromPrice) {
        if (priceNumber <= minusStep.fromPrice || priceNumber >= minusStep.toPrice) {
          this.determinePriceStep(priceNumber, isStopPrice);
        }
      } else {
        this.determinePriceStep(priceNumber, isStopPrice);
      }
      if (currentMarket === 'FUND') {
        this.handleFundFee(price)
      } else {
        const changeData = {
          price: isStopPrice ? this.priceRef.getValue() : priceNumber,
          quantity: this.quantityRef?.getValue(),
        }
        if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER) {
          changeData.stopPrice = isStopPrice ? priceNumber : this.stopPriceRef.getValue()
        }
        this.props.onChange(changeData);
        this.computeGrossAmount(changeData.price, changeData.quantity);
      }
    }

  }

  determinePriceStep(price, isStopPrice = false) {
    const { spreadTable ,instrument, marketType,lotSize,} = this.props;
    if( (instrument === "" && marketType === "Fund") || (lotSize === 1 && marketType === "Stock") ){
      return
    } 
    if (price &&　spreadTable.length>0 ) {
      for (let i = 0; i < spreadTable.length; i++) {
        const tmp = spreadTable[i];
        if (price < tmp.fromPrice || (price > tmp.fromPrice && price < tmp.toPrice)) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
          break;
        } else if (price == tmp.fromPrice) {
          const minusStep = i === 0 ? tmp : spreadTable[i - 1];
          isStopPrice
            ? this.setState({ stopPriceMinusStep: minusStep, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: minusStep, pricePlusStep: tmp })
          break;
        } else if (price == tmp.toPrice && i < spreadTable.length - 1) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: spreadTable[i + 1] })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: spreadTable[i + 1] })
          break;
        }
        if (i === spreadTable.length - 1) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
          break;
        }
      }
    } else {
      const tmp = spreadTable[0] || this.state.priceMinusStep;
      
      isStopPrice
        ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
        : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
    }

  }

  focusPrice = () => {
    this.priceRef.focusInput();
  }

  setQuantity = (qty) => {
    if(this.unitRef){
      this.unitRef?.setValue(qty);
    }else{
      this.quantityRef?.setValue(qty);
    }
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      const price = this.priceRef?.getValue();
      this.computeGrossAmount(price, qty);
    }
  }

  setPrice = (price) => {
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      if(this.amountRef){
        this.amountRef.setValue(price);
      }else{
        this.priceRef?.setValue(price);
      }
      
      const quantity = this.quantityRef?.getValue();
      this.computeGrossAmount(price, quantity);
    }
  }

  setGoodTillDate = (date) => {
    if (date) {
      this.goodTillDateRef.blur();
      this.goodTillDateRef.value=date;
      this.setState({datepicker :false})
    }
  }

  setOrderType = (type, orderData) => {
    if (type) {
      this.orderTypeRef.setValue([type]);
      this.setState({ orderType: type.value }, () => {
        if (type.value === ORDER_TYPE.TRIGGER_ORDER.value) {
          this.stopTypeDirectionRef.setValue([orderData.stopType]);
          this.stopPriceRef.setValue(orderData.stopPrice);
        }
      })
    }
  }

  reset = () => {
    const { currentMarket } = this.props

    if (currentMarket !== 'FUND') {
      this.setOrderType(this.props.orderTypes[0])
      this.setPrice(formatFunctions.dataFormat(0, dataType.CURRENCY));
      this.setQuantity(formatFunctions.dataFormat(0, dataType.NUMBER));
      // this.setGoodTillDate(this.props.forum_today);
      this.setGoodTillDate('-');
    } else {
      this.clearFundValues()
    }
  }

  validateInput = () => {
    if (this.priceRef || this.quantityRef) {
      this.priceRef.formatNumber(this.priceRef.getValue());
      this.quantityRef.formatNumber(this.quantityRef?.getValue());
      if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER.value) {
        this.stopPriceRef.formatNumber(this.stopPriceRef.getValue())
      }
    } else if (this.amountRef) {
      this.amountRef.formatNumber(this.amountRef.getValue());
      // this.unitRef.formatNumber(this.unitRef?.getValue());
    }
  }

  getOptions = () => {
    const { currentMarket } = this.props
    let orderType = JSON.parse(JSON.stringify(this.state.orderType));
    let goodTillDate = '';
    if (!this.props.isModifyOrder) {
      // orderType = this.orderTypeRef?.getValue()[0]
      // orderType = (val!=="FUND"?this.orderTypeRef?.getValue()[0]:this.props.currentFundActionType);

      if (currentMarket === 'FUND') {
        orderType = {value: '-'}
      } else {
        orderType = this.orderTypeRef?.getValue()[0]
      }

        const goodTillDateArray = this.goodTillDateRef;
        if (goodTillDateArray.value === '-') {
          goodTillDate = {value:'-'}
          // if (goodTillDate.value === DESELECT_OPTION) {
          //   goodTillDate = '';
          // }
        }else{
          goodTillDate = goodTillDateArray
        }
    }
    // let orderType = JSON.parse(JSON.stringify(this.state.orderType));
    // let goodTillDate = '';
    // if (!this.props.isModifyOrder) {
    //   orderType = this.orderTypeRef.getValue()[0];
    //   const goodTillDateArray = this.goodTillDateRef.getValue();
    //   if (goodTillDateArray.length > 0) {
    //     goodTillDate = goodTillDateArray[0]
    //     if (goodTillDate.value === DESELECT_OPTION) {
    //       goodTillDate = '';
    //     }
    //   }
    // }
    const amount = this.amountRef?.getValue()
    const unit = this.unitRef?.getValue()
    let quantity = this.quantityRef?.getValue();
    
    if (currentMarket === 'FUND') {
      if (this.props.currentFundActionType === FUND_ACTION_TYPES.SUBSCRIPTION) {
        quantity = '0'
      } else {
        quantity = unit
      }
    }
    const fee = this.props.currentFundActionType === FUND_ACTION_TYPES.SUBSCRIPTION ? this.state.fundAmount : this.state.fundUnit    
    let stopType = null;
    let stopPrice = null;
    if (!this.props.isModifyOrder && this.state.orderType === ORDER_TYPE.TRIGGER_ORDER.value) {
      stopType = this.stopTypeDirectionRef?.getValue()[0];
      stopPrice = this.stopPriceRef?.getValue();
    }
    if(utilsFunction.isOrderNeedEnterPrice(orderType)){
      let price
      if (currentMarket === 'FUND') {
        price = this.props.currentFundActionType === FUND_ACTION_TYPES.SUBSCRIPTION ? amount : '0'
      } else {
        price = this.priceRef?.getValue();
      }
      return {
        orderType,
        price,
        quantity,
        goodTillDate,
        stopType,
        stopPrice,
        amount,
        unit,
        fee      
      }
    }
    return {
      orderType,
      quantity,
      goodTillDate,
      stopType,
      stopPrice,
      amount,
      unit,
      fee    
    }
  }

  keySequence = (data) => {
    switch (data.currentKey) {
      case INDEX_KEY.PRICE:
        if (this.priceRef.getValue() === '0' || this.priceRef.getValue() === "") {
          return;
        }
        this.quantityRef?.inputRef.focus();
        break;
      case INDEX_KEY.QTY:
        if (this.quantityRef?.getValue() === '0' || this.quantityRef?.getValue() === "") {
          return;
        }
        this.quantityRef?.inputRef.blur();
        this.goodTillDateRef.focus();
        break;
      case INDEX_KEY.STOP_PRICE:
        if (this.stopPriceRef.getValue() === '0' || this.stopPriceRef.getValue() === "") {
          return;
        }
        this.priceRef.inputRef.focus();
        break;
      case INDEX_KEY.AMOUNT:
        if (this.amountRef.getValue() === '0' || this.amountRef.getValue() === "") {
          return;
        }
        this.goodTillDateRef.focus();
        break;
      case INDEX_KEY.UNIT:
        if (this.unitRef.getValue() === '0' || this.unitRef.getValue() === "") {
          return;
        }
        this.goodTillDateRef.focus();
        break;
      default:
        break;
    }
  }

  updatePriceStepInit = () => {
    const { spreadTable,quoteData,marketType} = this.props;
    if (spreadTable && spreadTable.length > 0 && quoteData != "" && quoteData ) {
      this.setState({
        priceMinusStep: spreadTable[0],
        pricePlusStep: spreadTable[0],
        stopPriceMinusStep: spreadTable[0],
        stopPricePlusStep: spreadTable[0]
      })
    }else if(marketType === 'Stock'){
      this.setState({
        stopPriceMinusStep: stopStockPriceMinusStep,
        stopPricePlusStep: stopStockPricePlusStep,
        priceMinusStep:priceStockMinusStep,
        pricePlusStep:priceStockPlusStep
      })
    }else{
      this.setState({
        stopPriceMinusStep: priceFundMinusStep,
        stopPricePlusStep: priceFundPlusStep,
        priceMinusStep:priceFundMinusStep,
        pricePlusStep:priceFundPlusStep
      })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.spreadTable !== this.props.spreadTable) {
      this.updatePriceStepInit();
    }
    if (prevProps.goodTillDates !== this.props.goodTillDates) {
      this.setState({
        newGoodTillDates: [{ value: DESELECT_OPTION, label: DESELECT_OPTION }, ...this.props.goodTillDates]
      })
    }

    if (this.props.currentMarket === 'FUND') {

    } else {
      if(prevProps.orderTypes !== this.props.orderTypes){
        // setTimeout(() => {
        //   this.setState({
        //     orderType:this.props.orderTypes[0]
        //   })
        // }, 200)
      }
      if(prevProps.cashAccountData !== this.props.cashAccountData || this.props.cashAccountData.buyingPower && this.props.quoteData?.last !== prevProps.quoteData?.last ||
        this.props.currentMarket && prevProps.currentMarket !== this.props.currentMarket
        ){
        if(this.props.quoteData.last){
          const availablebuy = Math.floor(this.props.cashAccountData.buyingPower?.replace(/,/g, "") / this.props.quoteData.last / this.props.lotSize) * this.props.lotSize
        this.setState({
          availablebuy : formatFunctions.dataFormat(availablebuy , dataType.NUMBER),
          selectQuatitybuyListData: [
            {
              label: `${this.props.language.available_for_buy}`,
              value : this.state.orderType.label === 'F' ? availablebuy : availablebuy-(availablebuy%this.props.lotSize),
              id:'1'
            },
            {
              label: `${this.props.language.common_buy} 1/2`,
              value : this.state.orderType.label === 'F' ? (availablebuy /2) : (availablebuy /2)-((availablebuy /2)%this.props.lotSize),
              id:'2'
            },{
              label: `${this.props.language.common_buy} 1/4`,
              value : this.state.orderType.label === 'F' ? (availablebuy /4) : (availablebuy /4)-((availablebuy /4)%this.props.lotSize),
              id:'3'
            },
          ]
        })
        }else{
          this.setState({
            availablebuy : '0',
            selectQuatitybuyListData: [
              {
                label: `${this.props.language.available_for_buy}`,
                value : '0',
                id:'1'
              },
              {
                label: `${this.props.language.common_buy} 1/2`,
                value : '0',
                id:'2'
              },{
                label: `${this.props.language.common_buy} 1/4`,
                value : '0',
                id:'3'
              },
            ]
          })
        }
      }
      if(prevProps.avaiableQuantity !== this.props.avaiableQuantity || this.props.cashAccountData.buyingPower && this.props.quoteData?.last !== prevProps.quoteData?.last){
        this.setState({
          avaiableQuantity : formatFunctions.dataFormat(this.props.avaiableQuantity ,dataType.NUMBER),
          selectQuatitysellListData: [
            {
              label: `${this.props.language.available_for_sell}`,
              value : this.state.orderType.label === 'F' ? this.props.avaiableQuantity : this.props.avaiableQuantity-(this.props.avaiableQuantity%this.props.lotSize),
              id:'4'
            },
            {
              label: `${this.props.language.common_sell} 1/2`,
              value : this.state.orderType.label === 'F' ? (this.props.avaiableQuantity /2) : (this.props.avaiableQuantity /2)-((this.props.avaiableQuantity /2)%this.props.lotSize),
              id:'5'
            },{
              label: `${this.props.language.common_sell} 1/4`,
              value :this.state.orderType.label === 'F' ? (this.props.avaiableQuantity /4) : (this.props.avaiableQuantity /4)-((this.props.avaiableQuantity /4)%this.props.lotSize),
              id:'6'
            },
          ]
        })
      }
      if(this.props.language != prevProps.language){
        // this.goodTillDateRef.value=this.props.language.forum_today
        const availablebuy = Math.floor(this.props.cashAccountData.buyingPower?.replace(/,/g, "") / this.props.quoteData.last / this.props.lotSize) * this.props.lotSize
        this.setState({
          selectPriceListData : [`${this.props.language.follow_price}`,`${this.props.language.follow_bid1}`,`${this.props.language.follow_ask1}`],
          selectQuatitybuyListData: [
            {
              label: `${this.props.language.available_for_buy}`,
              value : this.state.orderType.label === 'F' ? availablebuy : availablebuy-(availablebuy%this.props.lotSize),
              id:'1'
            },
            {
              label: `${this.props.language.common_buy} 1/2`,
              value : this.state.orderType.label === 'F' ? (availablebuy /2) : (availablebuy /2)-((availablebuy /2)%this.props.lotSize),
              id:'2'
            },{
              label: `${this.props.language.common_buy} 1/4`,
              value : this.state.orderType.label === 'F' ? (availablebuy /4) : (availablebuy /4)-((availablebuy /4)%this.props.lotSize),
              id:'3'
            },
          ],
          selectQuatitysellListData: [
            {
              label: `${this.props.language.available_for_sell}`,
              value : this.state.orderType.label === 'F' ? this.props.avaiableQuantity : this.props.avaiableQuantity-(this.props.avaiableQuantity%this.props.lotSize),
              id:'4'
            },
            {
              label: `${this.props.language.common_sell} 1/2`,
              value : this.state.orderType.label === 'F' ? (this.props.avaiableQuantity /2) : (this.props.avaiableQuantity /2)-((this.props.avaiableQuantity /2)%this.props.lotSize),
              id:'5'
            },{
              label: `${this.props.language.common_sell} 1/4`,
              value :this.state.orderType.label === 'F' ? (this.props.avaiableQuantity /4) : (this.props.avaiableQuantity /4)-((this.props.avaiableQuantity /4)%this.props.lotSize),
              id:'6'
            },
          ]
        })
      }
    }
  }
  hiddenList=()=>{
    this.setState({
      priceSelectList : false,
      quantitySelectList :false,
      // datepicker : false
    })
  }
  componentDidMount() {

    this.updatePriceStepInit();
    document.addEventListener('click' , this.hiddenList)
  }

  componentWillUnmount = () =>{
    this.setState = ()=>{}
    document.removeEventListener('click' , this.hiddenList)
  }

  selectPrice=(index)=>{
    let changeData;
    switch (index) {
      case 0:
        this.priceRef.setValue(this.props.quoteData.last);
        changeData = {
          price: this.props.quoteData.last ,
          quantity: this.quantityRef.getValue(),
        }
        this.handleChangePrice(changeData.price);
        break;
      case 1:
        this.priceRef.setValue(this.props.biddata[0]?.price || '0');
        changeData = {
          price: this.props.biddata[0]?.price || '0' ,
          quantity: this.quantityRef.getValue(),
        }
        this.handleChangePrice(changeData.price);
        break;
      case 2:
        this.priceRef.setValue(this.props.askdata[0]?.price || '0');
        changeData = {
          price: this.props.askdata[0]?.price || '0',
          quantity: this.quantityRef.getValue(),
        }
        this.handleChangePrice(changeData.price);
        break;

      default:
        break;
    }
    this.setState({quantitySelectList : false ,priceSelectList:false})
    
  }

  selectQuantity=(item)=>{
    this.quantityRef?.setValue(item.value);
    const changeData = {
      price: this.priceRef.getValue() ,
      quantity: item.value,
    }
    this.handleChangeQuantity(changeData.quantity);
    // this.computeGrossAmount(changeData.price, changeData.quantity);
    this.setState({quantitySelectList : false ,priceSelectList:false})
  }


  setDatepicker=()=>{
    const {datepicker , orderType} = this.state
    if(!datepicker){
      this.goodTillDateRef.focus();
      this.setState({datepicker : true})
    }else{
      this.goodTillDateRef.blur();
      this.setState({datepicker : false})
    }
  }
}

PlaceOrderOption.defaultProps = {
  innerRef: () => {
  },
  tradeInformation: null,
  spreadTable: [],
  lotSize: 1,
  isModifyOrder: false,
  onChange: () => {
  },
  openGTDByTab: null,
  showGrossAmount: null,
  showGrossAmountBorder: false,
  currencyID: 'HKD'
}

export default connect(
  state => ({
    language: state.app.language,
    goodTillDates: state.trade.goodTillDates,
    orderTypes: state.trade.orderTypes,
    cashAccountData : state.trade.cashAccountData,
    currentMarket: state.trade.currentMarket,
    currentTradingAccount: state.trade.currentTradingAccount
  }),
  dispatch => ({
    getOrderFeesAction: (p, res) => dispatch(orderActions.getOrderFeesAction(p, res)),
    getAvailableQuantity: (p, res) => dispatch(accountActions.getAvailableQuantityAction(p, res)),
  })
)(PlaceOrderOption)
